import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import QuizHintV4 from './QuizHintV4';
import QuizInputV4 from './QuizInputV4';
import ICON_A from '../../../../public/static/v4/event/icon-quiz-a.svg';
import ICON_Q from '../../../../public/static/v4/event/icon-quiz-q.svg';
import EllipsisText from '../../../common/component/EllipsisText';
import {showAuthModal} from '../../../common/function';
import useLogin from '../../../common/hook/useLogin';
import {EVENT_MAX_WIDTH_272_CN} from '../../common';
import {actions} from '../../state/action';
import {IQuizModuleV4} from '../../type';
import ModuleSectionV4 from '../ModuleSectionV4';

interface IProps {
  data: IQuizModuleV4;
}

export default function MissionQuizModuleV4({data}: IProps) {
  const {t} = useTranslation();
  const {section, quizTitle, hint, isCompleted} = data;

  const {isLogin} = useLogin();
  const dispatch = useDispatch();
  const handleSubmit = (keyword: string) => {
    if (isLogin) {
      dispatch(actions.fetchQuizAnswer(keyword.trim()));
    } else {
      openAuthModal();
    }
  };
  const openAuthModal = () => showAuthModal({isSaveReturnPage: true});

  return (
    <>
      <ModuleSectionV4
        section={section}
        innerClassName="flex flex-col gap-y-10"
        data-module-type="quiz"
      >
        <img src={ICON_Q} className="w-38 h-32" alt="Q" />
        <EllipsisText
          line={5}
          className={cn(
            's22-bold-white leading-28 tracking-[-0.5px]',
            EVENT_MAX_WIDTH_272_CN
          )}
        >
          {quizTitle}
        </EllipsisText>
        {hint && <QuizHintV4 hintLabel={t('crm_quiz_hint')} hint={hint} />}
      </ModuleSectionV4>
      <ModuleSectionV4
        className="mt-32"
        innerClassName="flex flex-col gap-y-10"
      >
        <img src={ICON_A} className="w-38 h-32" alt="A" />
        <QuizInputV4
          isCompleted={isCompleted}
          isDisabled={!isLogin}
          onSubmit={handleSubmit}
          onClickForm={!isLogin ? openAuthModal : undefined}
        />
      </ModuleSectionV4>
    </>
  );
}
